import { activeProfileSearch, deleteUserService,
  deleteCarrierListingById, deleteCarrierById,
  getAgencyCodeUserPsw,
  getUserDetailsService,
  updateInsuranceCarrier ,getCarrier, getGroupCarrier,
  getAllCarrier,
  getProfile, getProfileUser, saveCarrier,
  saveCarrierGroup, saveProfile, searchAgency,
  updateCarrier, updateProfile, getAllLocations,
  searchUserService, getUserInfoService,
  searchManageCarrierListingServices,
  searchCompanyGroupServices,
  searchCarrierListService,
  deleteCarrierGroupServices,
  getCompanyGroups,
  getUserPermissionService,
searchUserNameService,
getCarrierListWithStateServices,
getUserAllPermissionService} from "../../services/agencyServices";
import { updateUser } from "../../services/userServices";
import { STOP_LOADING,START_LOADING } from "./actionTypes";
import { openSessionTimeoutModal } from './sessionTimeOutActions';
// export const saveCarrierAction = (formData, callbackfn) => async (dispatch, getState) => {
//     try {
//       dispatch({ type: START_LOADING, service: 'SAVE_AGENCY' });
//       const token = getState().auth.token || sessionStorage.getItem("token");
//       const response = await saveCarrier(formData, token);
//       dispatch({ type: STOP_LOADING, service: 'SAVE_AGENCY' });
//       if (response) {
//         callbackfn(response);
//       }
//       dispatch({ type: 'SAVE_AGENCY_SUCCESS', payload: response }); // Dispatch the success action with response data
//     } catch (error) {
//       dispatch({ type: STOP_LOADING, service: 'SAVE_AGENCY' });
//         dispatch({ type: 'SAVE_AGENCY_FAILURE', payload: error || 'Save agency service failed. Please try again.' });
//     }
//   };

export const saveCarrierAction = (formData, callbackfn) => async (dispatch, getState) => {
    try {
      dispatch({ type: START_LOADING, service: 'SAVE_AGENCY' });
      const token = getState().auth.token || sessionStorage.getItem("token");
      const response = await saveCarrier(formData, token);
      dispatch({ type: STOP_LOADING, service: 'SAVE_AGENCY' });
      if (response) {
        callbackfn({ success: true, data: response });
      }
      dispatch({ type: 'SAVE_AGENCY_SUCCESS', payload: response });
    } catch (error) {
      dispatch({ type: STOP_LOADING, service: 'SAVE_AGENCY' });
      dispatch({ type: 'SAVE_AGENCY_FAILURE', payload: error || 'Save agency service failed. Please try again.' });
      // Pass error details to callback
      callbackfn({ success: false, error: error });
    }
  };
export const saveCarrierGroupAction = (formData, callbackfn) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'SAVE_CARRIERGROUP' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await saveCarrierGroup(formData, token);
     dispatch({ type: STOP_LOADING, service: 'SAVE_CARRIERGROUP' });

      dispatch({ type: 'SAVE_CARRIER_GROUP_SUCCESS', payload: response }); // Dispatch the success action with response data
    return response;
  } catch (error) {
    dispatch({ type: STOP_LOADING, service: 'SAVE_CARRIERGROUP' });
    if (error?.message?.includes("403")) {
      dispatch(openSessionTimeoutModal());
    } else {
      dispatch({
        type: 'SAVE_CARRIER_GROUP_FAILURE',
        payload: error.message || 'Save carrier group service failed. Please try again.'
      });
    }
    throw error;
  }
};

  export const getCarrierAction = (page =0, rowsPerPage=5) => async (dispatch, getState) => {
    try {
      dispatch({ type: START_LOADING, service: 'ALL_CARRIER_INFOS' });
      const token = getState().auth.token||sessionStorage.getItem("token");
      const response = await getCarrier(token, page, rowsPerPage);
      dispatch({ type: STOP_LOADING, service: 'ALL_CARRIER_INFOS' });
      dispatch({ type: 'ALL_CARRIER_INFOS_SUCCESS', payload: response });
    } catch (error) {
      dispatch({ type: STOP_LOADING, service: 'ALL_CARRIER_INFOS' });
      dispatch({ type: 'ALL_CARRIER_INFOS_FAILURE', payload: error.message || 'All agency service failed. Please try again.' });
    }
  };

   export const getAllCarrierAction = (page =0, rowsPerPage=5) => async (dispatch, getState) => {
    try {
      dispatch({ type: START_LOADING, service: 'START_LOADING' });
      const token = getState().auth.token||sessionStorage.getItem("token");
      const response = await getAllCarrier(token, page, rowsPerPage);
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
      dispatch({ type: 'GET_ALL_CARRIER_INFOS_SUCCESS', payload: response });
    } catch (error) {
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
      dispatch({ type: 'GET_ALL_CARRIER_INFOS_FAILURE', payload: error.message || 'All agency service failed. Please try again.' });
    }
  };

  export const getGroupCarrierAction = (page = 1, size = 5) => async (dispatch, getState) => {
    try {
      dispatch({ type: START_LOADING, service: 'ALL_CARRIER_INFOS' });
      const token = getState().auth.token||sessionStorage.getItem("token");
      const response = await getGroupCarrier(token, page, size);
      dispatch({ type: STOP_LOADING, service: 'ALL_CARRIER_INFOS' });
      dispatch({ type: 'ALL_CARRIER_GROUP_INFOS_SUCCESS', payload: response });
    } catch (error) {
      dispatch({ type: STOP_LOADING, service: 'ALL_CARRIER_INFOS' });
      dispatch({ type: 'ALL_CARRIER_GROUP_INFOS_FAILURE', payload: error.message || 'All agency service failed. Please try again.' });
    }
  };

  export const searchAgencyAction = (formData, callbackfn) => async (dispatch, getState) => {
    try {
      dispatch({ type: START_LOADING, service: 'SEARCH_AGENCY' });
      const token = getState().auth.token || sessionStorage.getItem("token");
      const response = await searchAgency(formData, token);
      dispatch({ type: STOP_LOADING, service: 'SEARCH_AGENCY' });
      if (response) {
        callbackfn(response);
      }
      dispatch({ type: 'SEARCH_AGENCY_SUCCESS', payload: response }); // Dispatch the success action with response data
    } catch (error) {
      if (error?.includes("403")) {
        dispatch(openSessionTimeoutModal());
      } else {
        dispatch({ type: STOP_LOADING, service: 'SEARCH_AGENCY' });
        dispatch({ type: 'SEARCH_AGENCY_FAILURE', payload: error || 'Save agency service failed. Please try again.' });
      }
    }
  };

  export const updateCarrierAction = (formData,callbackfn) => async (dispatch, getState) => {
    try {
      dispatch({ type: START_LOADING, service: 'UPDATE_CARRIER' });
      const token = getState().auth.token || sessionStorage.getItem("token");
      const response = await updateCarrier(formData, token);
      dispatch({ type: STOP_LOADING, service: 'UPDATE_CARRIER' });

      dispatch({ type: 'UPDATE_CARRIER_SUCCESS', payload: response });
    } catch (error) {
      if(error?.includes("403")) {
        dispatch(openSessionTimeoutModal());
      } else {
        dispatch({ type: STOP_LOADING, service: 'UPDATE_CARRIER' });
        dispatch({ type: 'UPDATE_CARRIER_FAILURE', payload: error || 'Update agency service failed. Please try again.' });
      }
    }
  };

  export const updateInsuranceCarrierAction = (formData, callbackfn) => async (dispatch, getState) => {
    try {
      dispatch({ type: START_LOADING, service: 'START_LOADING' });
      const token = getState().auth.token || sessionStorage.getItem("token");

      const response = await updateInsuranceCarrier(formData, token);

      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
      dispatch({ type: 'UPDATE_INSURANCE_CARRIER', payload: response });

      if (response) callbackfn({success: true, data: response});
    } catch (error) {

        dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
        dispatch({
          type: 'UPDATE_CARRIER_FAILURE',
          payload: error || 'Update agency service failed. Please try again.',
        });

        if (callbackfn) callbackfn({ success: false, error: error });

    }
  };

  export const deleteCarrierByIdAction = (id) => async (dispatch, getState) => {
    try {
      dispatch({ type: START_LOADING, service: 'START_LOADING' });
      const token = getState().auth.token || sessionStorage.getItem("token");
      await deleteCarrierById(id, token); // API call to delete the group
      dispatch({ type: 'DELETE_CARRIER_GROUP', payload: id });

      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    } catch (error) {
      dispatch({ type: 'GET_LOCATION_GROUPS_FAILURE', payload: error || 'Failed to delete group. Please try again.' });
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' }); // Stop loading on error as well
    }
  };

  export const deleteCarrierListingByIdAction = (id) => async (dispatch, getState) => {
    try {
      dispatch({ type: START_LOADING, service: 'START_LOADING' });
      const token = getState().auth.token || sessionStorage.getItem("token");
      await deleteCarrierListingById(id, token); // API call to delete the group
      dispatch({ type: 'DELETE_CARRIER_LISTING_ITEM_SUCCESS', payload: id });

      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    } catch (error) {
      if(error?.includes("403")) {
        dispatch(openSessionTimeoutModal());
      } else {
        dispatch({ type: 'DELETE_CARRIER_LISTING_ITEM_FAILURE', payload: error || 'Failed to delete group. Please try again.' });
        dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' }); // Stop loading on error as well
      }
    }
  };

  export const clearProfileData = () => (dispatch) => {
    dispatch({ type: 'CLEAR_PROFILE_DATA' });
  };

  export const saveProfileAction = (formData, callbackfn) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'SAVE_PROFILE' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await saveProfile(formData, token);
    dispatch({ type: STOP_LOADING, service: 'SAVE_PROFILE' });

    clearProfileData();

    if (response) {
      callbackfn(response);  // Success callback
    }
    dispatch({ type: 'SAVE_PROFILE_SUCCESS', payload: response });
  } catch (error) {
    dispatch({ type: STOP_LOADING, service: 'SAVE_PROFILE' });

    const errorData = error.errors ? error : {
      errors: [{
        errorMessage: 'Save profile failed. Please try again.',
        target: null
      }]
    };
    dispatch({
      type: 'SAVE_PROFILE_FAILURE',
      payload: errorData
    });

    callbackfn(null, error);
  }
};

export const searchActiveProfileAction = (formData, page, rowsPerPage ) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await activeProfileSearch(formData, token,page, rowsPerPage);
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });

    dispatch({ type: 'SAVE_PROFILE_SEARCH_SUCCESS', payload: response }); // Dispatch the success action with response data
  } catch (error) {
    if (error?.includes("403")) {
      dispatch(openSessionTimeoutModal());
    } else {
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
      dispatch({ type: 'SAVE_PROFILE_SEARCH_FAILURE', payload: error || 'Save profile service failed. Please try again.' });
    }
  }
};

export const getProfileAction = (page = 0, size = 5) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'ALL_PROFILE_INFOS' });
    const token = getState().auth.token||sessionStorage.getItem("token");
    const response = await getProfile(token,page,size);
    dispatch({ type: STOP_LOADING, service: 'ALL_PROFILE_INFOS' });
    dispatch({ type: 'ALL_PROFILE_INFOS_SUCCESS', payload: response });
  } catch (error) {
    dispatch({ type: STOP_LOADING, service: 'ALL_PROFILE_INFOS' });
    dispatch({ type: 'ALL_PROFILE_INFOS_FAILURE', payload: error.message || 'All profile service failed. Please try again.' });
  }
};

export const deleteUserAction = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token||sessionStorage.getItem("token");
    const response = await deleteUserService(token, id);
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    dispatch({ type: 'DELETE_USER_PROFILE', payload: response });
  } catch (error) {
    dispatch({ type: STOP_LOADING, service: 'ALL_PROFILE_INFOS' });
    dispatch({ type: 'ALL_PROFILE_INFOS_FAILURE', payload: error.message || 'All profile service failed. Please try again.' });
  }
};

export const getProfileUserAction = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'ALL_PROFILE_INFOS' });
    const token = getState().auth.token||sessionStorage.getItem("token");
    const response = await getProfileUser(id,token);
    dispatch({ type: STOP_LOADING, service: 'ALL_PROFILE_INFOS' });
    dispatch({ type: 'ALL_PROFILE_INFOS_SUCCESS', payload: response });
  } catch (error) {
    dispatch({ type: STOP_LOADING, service: 'ALL_PROFILE_INFOS' });
    dispatch({ type: 'ALL_PROFILE_INFOS_FAILURE', payload: error.message || 'All profile service failed. Please try again.' });
  }
};


export const updateProfileAction = (formData, callbackfn) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });

    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await updateProfile(formData, token);

    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    dispatch({ type: 'UPDATE_PROFILE_SUCCESS', payload: response });

    callbackfn(true, null);  // success = true

  } catch (error) {
     dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });

  const errorsFromApi = error?.response?.data?.errors || [
    { errorMessage: 'Something went wrong. Please try again.', target: 'general' }
  ];


  dispatch({ type: 'UPDATE_PROFILE_FAILURE', payload: errorsFromApi });

  callbackfn(null, { errors: errorsFromApi });
  }
};


export const updatedLoggedInUserProfile = (formData, callbackfn) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await updateUser(formData, token);
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    if (response) {
      callbackfn(response);  // Success callback
    }
    dispatch({ type: 'LOGGEDIN_USER_PROFILE_SUCCESS', payload: response });
  } catch (error) {
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    dispatch({ type: 'LOGGEDIN_USER_PROFILE_SUCCESS', payload: error.message || 'All profile service failed. Please try again.' });
  }
};


export const getAllLocationsAction = () => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await getAllLocations(token);
    dispatch({ type: 'GET_ALL_LOCATIONS_SUCCESS', payload: response });

    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
  } catch (error) {
    dispatch({ type: 'GET_ALL_LOCATIONS_FAILURE', payload: error || 'Failed to delete group. Please try again.' });
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' }); // Stop loading on error as well
  }
};

export const getSelectedUserDetailsAction = (id, callbackfn) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token||sessionStorage.getItem("token");
    const response = await getUserDetailsService(token, id);
    if(response) {
      callbackfn(response);  // Success callback
    }
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    dispatch({ type: 'GET_USER_DETAILS_SUCCESS', payload: response });
  } catch (error) {
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    dispatch({ type: 'GET_USER_DETAILS_FAILURE', payload: error.message || 'User Profile details service failed. Please try again.' });
  }
};

export const getSearchUserList = (formdata,page=0,size=5) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token||sessionStorage.getItem("token");
    const response = await searchUserService(token, formdata,page,size)

    dispatch({ type: "GET_ALL_SEARCH_USER_SUCCESS", payload: response });
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
  } catch (error) {
    dispatch({ type: "GET_ALL_SEARCH_USER_FAILURE", payload: error.message || 'User Profile details service failed. Please try again.' });
    throw error;
  }
};

export const getAgencyCodeUserPswAction = (id) => async (dispatch, getState) => {
    try {
      dispatch({ type: START_LOADING, service: 'START_LOADING' });
      const token = getState().auth.token || sessionStorage.getItem("token");
      const response = await getAgencyCodeUserPsw(id, token); // API call to delete the group
      dispatch({ type: 'GET_AGENCY_CODE_USER_PSW_SUCCESS', payload: response });

      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    } catch (error) {
      dispatch({ type: 'GET_AGENCY_CODE_USER_PSW_FAILURE', payload: error || 'Failed to get user code group. Please try again.' });
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' }); // Stop loading on error as well
    }
  };

  export const getUserInfoAction = () => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token||sessionStorage.getItem("token");
    const response = await getUserInfoService(token)

    dispatch({ type: "GET_USER_INFO_SUCCESS", payload: response });
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
  } catch (error) {
    dispatch({ type: "GET_USER_INOF_FAILURE", payload: error.message || 'User Info details service failed. Please try again.' });
    throw error;
  }
};

export const searchManageCarrierListingAction = (keyword, page = 0, size = 5) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await searchManageCarrierListingServices(keyword, token, page, size);
    dispatch({ type: 'GET_SEARCH_MANAGE_CARRIER_LISTING_SUCCESS', payload: response,
    });
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
  } catch (error) {
    dispatch({ type: 'GET_SEARCH_MANAGE_CARRIER_LISTING_FAILURE', error,});
  }
};

export const searchCompanyGroupAction = (keyword, carrierName, page = 0, size = 5) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await searchCompanyGroupServices(keyword, carrierName, token, page, size);
    dispatch({ type: 'GET_SEARCH_CARRIER_RESULT_LIST_SUCCESS', payload: response });
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
  } catch (error) {
    dispatch({ type: 'GET_SEARCH_CARRIER_RESULT_LIST_FAILURE', payload: error });
  }
};

export const searchUserNameAction = (username, callbackfn) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await searchUserNameService(username, token);
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    if (response) {
      callbackfn(response);  // Success callback
    }
    dispatch({ type: 'GET_SEARCH_USER_NAME_SUCCESS', payload: response });
  } catch (error) {
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });

  }
};


export const getCarrierListWithStateAction = (stateCode, page = 0, size = 5) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token||sessionStorage.getItem("token");
    const response = await getCarrierListWithStateServices(stateCode, token, page, size);
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    dispatch({ type: 'GET_CARRIER_LIST_WITH_STATE_SUCCESS', payload: response });
  } catch (error) {
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    dispatch({ type: 'GET_CARRIER_LIST_WITH_STATE_FAILURE', payload: error.message || 'Get carrier list with state failed. Please try again.' });
  }
};

export const deleteCarrierGroupAction = (companyGroupId, carrierId, stateCode) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token||sessionStorage.getItem("token");
    const response = await deleteCarrierGroupServices(companyGroupId, carrierId, stateCode, token);
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    dispatch({ type: 'DELETE_GROUP_CARRIER_SUCCESS', payload: response });
  } catch (error) {
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    dispatch({ type: 'DELETE_GROUP_CARRIER_FAILURE', payload: error.message || 'Delete carrier failed. Please try again.' });
  }
};

export const fetchCompanyGroups = () => async (dispatch, getState) => {
  try {
    dispatch({ type: 'START_LOADING' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await getCompanyGroups(token);
    dispatch({ type: 'GET_COMPANY_GROUPS_SUCCESS', payload: response });
  } catch (error) {
    dispatch({ type: 'GET_COMPANY_GROUPS_FAILURE', payload: error });
  } finally {
    dispatch({ type: 'STOP_LOADING' });
  }
};


  export const searchCarrierListAction = (formData, page = 0, size = 5) => async (dispatch, getState) => {
    try {
      dispatch({ type: START_LOADING, service: 'START_LOADING' });
      const token = getState().auth.token || sessionStorage.getItem("token");
      const response = await searchCarrierListService(formData, token, page, size);
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });

      dispatch({ type: 'GET_SEARCH_CARRIER_LIST_SUCCESS', payload: response }); // Dispatch the success action with response data
    } catch (error) {
      if (error?.includes("403")) {
        dispatch(openSessionTimeoutModal());
      } else {
        dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
        dispatch({ type: 'GET_SEARCH_CARRIER_LIST_FAILURE', payload: error || 'Save carrier group service failed. Please try again.' });
      }
    }
  };

   export const getUserPermissionAction = () => async (dispatch, getState) => {
    try {
      dispatch({ type: START_LOADING, service: 'START_LOADING' });
      const token = getState().auth.token || sessionStorage.getItem("token");
      const response = await getUserPermissionService(token);
      dispatch({ type: 'GET_USER_PERMISSION_SCCUESS', payload: response });
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    } catch (error) {
      if (error?.includes("403")) {
        dispatch(openSessionTimeoutModal());
      } else {
        dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
        dispatch({ type: 'GET_USER_PERMISSION_FAILURE', payload: error || 'Save carrier group service failed. Please try again.' });
      }
    }
  };

   export const getUserAllPermissionAction = (id) => async (dispatch, getState) => {
    try {
      dispatch({ type: START_LOADING, service: 'START_LOADING' });
      const token = getState().auth.token || sessionStorage.getItem("token");
      const response = await getUserAllPermissionService(id, token);
      dispatch({ type: 'GET_USER_ALL_PERMISSION_SCCUESS', payload: response });
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    } catch (error) {
        dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
        dispatch({ type: 'GET_USER_ALL_PERMISSION_FAILURE', payload: error || 'Save carrier group service failed. Please try again.' });
    }
  };


